module.exports = __webpack_public_path__ + "img/seul.851220cd.jpg";